// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1FC6f","inner":"Form_inner__3c8bU","range":"Form_range__17pY9","name":"Form_name__rJ5hi","actions":"Form_actions__PBYmN"};